import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  content: string;
  styleDef?: React.CSSProperties;
  type?: string;
}

const DefaultLabel: FC<Props> = ({ styleDef, type, content }) => {
  return (
    <div className={['_desc_label_box_div', type].join(' ')} style={styleDef}>
      <div className="_content">{content}</div>
    </div>
  );
};

export default DefaultLabel;
